import { collectionRef } from "@/api/collectionRef/collectionOperations";
import { _CollectionsNamesWithSlug } from "./common.type";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";

export async function _validateSlugBasedOnCollectionName(
  collectionName: _CollectionsNamesWithSlug,
  slug: string
) {
  const collectionDocs =
    collectionName === "profiles"
      ? await collectionRef
          .profiles(brand.tenantId)
          .where("slug", "==", slug)
          .limit(1)
          .get()
      : await (collectionName === "news"
          ? collectionRef.news(brand.tenantId)
          : collectionRef[collectionName]
        )
          .where("slug", "==", slug)
          .limit(1)
          .get();
  if (collectionDocs.empty) {
    return false;
  }
  return true;
}
